__turbopack_context__.v({
  "closeButton": "LoggedInContent-module-scss-module__SRu2DG__closeButton",
  "content": "LoggedInContent-module-scss-module__SRu2DG__content",
  "greetingHeading": "LoggedInContent-module-scss-module__SRu2DG__greetingHeading",
  "header": "LoggedInContent-module-scss-module__SRu2DG__header",
  "navLink": "LoggedInContent-module-scss-module__SRu2DG__navLink",
  "navLinkText": "LoggedInContent-module-scss-module__SRu2DG__navLinkText",
  "navList": "LoggedInContent-module-scss-module__SRu2DG__navList",
  "navigation": "LoggedInContent-module-scss-module__SRu2DG__navigation",
  "signOutButton": "LoggedInContent-module-scss-module__SRu2DG__signOutButton",
});
